import React from 'react'
import PropTypes from 'prop-types'

const Pagination = ({
  prevDisabled,
  nextDisabled,
  pageNumber,
  setPageNumber,
  totalPages,
  onButtonClick = () => { }
}) => (
  totalPages > 0 && (
    <div className='d-flex fw-semibold text-nowrap mx-0 mx-lg-4 my-3 my-lg-0'>
      <a
        aria-label='First'
        disabled={prevDisabled}
        className={`${prevDisabled ? 'opacity-50' : 'text-link'} text-decoration-none me-3`}
        onClick={() => {
          !prevDisabled && setPageNumber(1)
          onButtonClick()
        }}
      >
        <span className='fas fa-angle-double-left' />
        <span className='d-none d-lg-inline'> First</span>
      </a>

      <a
        aria-label='Previous'
        disabled={prevDisabled}
        className={`${prevDisabled ? 'opacity-50' : 'text-link'} text-decoration-none me-3`}
        onClick={() => {
          !prevDisabled && setPageNumber(pageNumber - 1)
          onButtonClick()
        }}
      >
        <span className='fas fa-angle-left' />
        <span className='d-none d-lg-inline'> Back</span>
      </a>

      <div className='text-muted'>{`Page ${pageNumber} of ${totalPages}`}</div>

      <a
        aria-label='Next'
        disabled={nextDisabled}
        className={`${nextDisabled ? 'opacity-50' : 'text-link'} text-decoration-none ms-3`}
        onClick={() => {
          !nextDisabled && setPageNumber(pageNumber + 1)
          onButtonClick()
        }}
      >
        <span className='d-none d-lg-inline'>Next </span>
        <span className='fas fa-angle-right' />
      </a>

      <a
        aria-label='Last'
        disabled={nextDisabled}
        className={`${nextDisabled ? 'opacity-50' : 'text-link'} text-decoration-none ms-3`}
        onClick={() => {
          !nextDisabled && setPageNumber(totalPages)
          onButtonClick()
        }}
      >
        <span className='d-none d-lg-inline'>Last </span>
        <span className='fas fa-angle-double-right' />
      </a>
    </div>
  )
)

Pagination.propTypes = {
  prevDisabled: PropTypes.bool,
  nextDisabled: PropTypes.bool,
  setPageNumber: PropTypes.func,
  onButtonClick: PropTypes.func,
  pageNumber: PropTypes.number,
  totalPages: PropTypes.number
}

export default Pagination
